import { convertToShortMonth, dateFormating, convertToShortMonthDutch } from "@/util"

export default class CMGroupedMonth {
  constructor(item) {
    this.label = convertToShortMonthDutch(item.date)
    this.dates = [item]
  }
}